import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Counter from '../Home/Counter/Counter.js'

const BannerBottom = (props) => {
    const { glstrapi } = useStaticQuery(graphql`
        query AuctionsPropertyPageQuery {
            glstrapi {
                articles(where: { Alias: "auction-property-search" }) {
                    id
                    Pagename
                    Alias
                    Layout
                    Modules {
                        __typename
                        ... on GLSTRAPI_ComponentComponentBannerBottom {
                            Banner_Bottom_Module {
                                id
                                Link
                                Heading
                                Content
                            }
                        }
                    }
                }
            }
        }
    `)

    var article_page = glstrapi?.articles?.length > 0 && glstrapi.articles[0];
    var counter_module = article_page?.Modules?.filter(Module => Module.__typename === "GLSTRAPI_ComponentComponentBannerBottom");

    return (
        <React.Fragment>
            {/* ======= Banner Bottom ======= */}
            {
                counter_module?.length > 0 && counter_module?.map((Module, i) =>{
                    return(
                        <Counter Module={Module} Layout={article_page.Layout} />
                    )
                })
            }
            {/* ======= Banner Bottom ======= */}
        </React.Fragment>
    )
}
export default BannerBottom
